import { scope } from "@gr-exports/async/debug";
const grScope = scope("gr");
export {
  grScope
};
